module.exports = __webpack_public_path__ + "static/media/Put-local-on-your-tray-clear-background-400x317.d7544d22.png";